function whenPageReady() {
  return new Promise((resolve) => {
    if (document.readyState === "complete") {
      // When the page is already loaded and user clicks the A2C button
      resolve();
    } else {
      // When the page is not yet loaded and user clicks the A2C button
      window.addEventListener("load", resolve, {once: true});
    }
  });
}

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();
        this.form = this.querySelector("form");
        var nameId = this.form.querySelector("[name=id]");
        if (nameId) {
          nameId.disabled = false;
        }
        this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
        this.cart =
          document.querySelector("cart-notification") ||
          document.querySelector("cart-drawer");
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector("cart-drawer"))
          this.submitButton.setAttribute("aria-haspopup", "dialog");
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        // if (this.submitButton.getAttribute("aria-disabled") === "true") return;

        this.handleErrorMessage();
        this.submitButton.setAttribute("aria-disabled", true);
        this.submitButton.classList.add("loading");
        this.querySelector(".loading-overlay__spinner").classList.remove(
          "hidden"
        );
        await whenPageReady();
        console.log("PAGE READY -> SUBMIT HANDLING");

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              this.submitButton.querySelector("span").classList.add("hidden");
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");
            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                {once: true}
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");
            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");
            if (!this.error) this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading-overlay__spinner").classList.add(
              "hidden"
            );
            this.afteraddtocart();
          });
      }

      handleErrorMessage(errorMessage = false) {
        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      afteraddtocart() {
        document.querySelector(".product-form__submit").classList.add("added");
        document.querySelector(".product-form__submit span").innerHTML =
          "Added";
        document.querySelector("cart-drawer.drawer").classList.add("active");
        document.querySelector("html").classList.add("disable-scroll");
        // document.querySelector('.top-btn').classList.add('show');
        // document.querySelector('.bottom-btn').classList.add('show');
        var elementPosition = document.querySelector(
          ".addons-tab-wrapper"
        ).offsetTop;

        var addtocart_wrapper = document.querySelector(".product-form__wrap");
        if (!addtocart_wrapper.classList.contains("mday")) {
          var popup_status = sessionStorage.getItem("collection_popup_status");
          var soldout_popup = JSON.parse(
            sessionStorage.getItem("soldout_popup")
          );
          var soldout_status = soldout_popup?.status;
          console.log({soldout_status});
          if (popup_status != "shown" && soldout_status != "shown") {
            $(".hover_bkgr_fricc").show();
            $(".hover_bkgr_fricc").addClass("active-popup");
            sessionStorage.setItem("collection_popup_status", "shown");
          }
        }

        refreshFsLightbox();
        hide_addon_tab();
        initCountdown();
        setTimeout(function () {
          // window.scrollTo({
          //   top: elementPosition - 100,
          //   behavior: "smooth"
          // });
          document
            .querySelector(".product-form__submit")
            .classList.remove("added");
          document.querySelector(".product-form__submit span").innerHTML =
            "Proceed to Checkout";

          var button_sec = document.querySelector(
            ".addtocart-btn-trigger .button"
          );
          button_sec.classList.add("sec-checkout-btn");
          button_sec.classList.remove("disabled");
          button_sec.removeAttribute("disabled");
          var svgElement = button_sec.querySelector("svg");
          document.querySelector(
            ".addtocart-btn-trigger .button span"
          ).innerHTML = "Proceed to Checkout";
          document
            .querySelector(".product-form__submit")
            .classList.add("sec-checkout-btn");
          document.querySelector(
            ".product-form__submit"
          ).dataset.additionalProductsHandled = "true";
          if (svgElement) {
            button_sec.removeChild(svgElement);
          }
        }, 1500);
      }
    }
  );
}

// Mobile Add To Cart Sticky Header
// document.addEventListener("DOMContentLoaded", function () {
//   function addClassWhenTouchingHeader(selector, className, options = {}) {
//     const header = document.querySelector(options.headerSelector || '.header_main');
//     if (!header) return;

//     const targets = Array.from(document.querySelectorAll(selector));
//     if (!targets.length) return;

//     let ticking = false;
//     let headerHeight = header.getBoundingClientRect().height;

//     const onResize = () => {
//       headerHeight = header.getBoundingClientRect().height;
//       check();
//     };
//     window.addEventListener('resize', throttle(onResize, 150));

//     const mo = new MutationObserver(onResize);
//     mo.observe(header, { childList: true, subtree: true, attributes: true });

//     function check() {
//       headerHeight = header.getBoundingClientRect().height;

//       for (const el of targets) {
//         const rect = el.getBoundingClientRect();
//         const nextEl = el.nextElementSibling;

//         const touchedOrAbove = rect.top <= headerHeight;
//         const completelyAbove = rect.bottom <= headerHeight;

//         if (touchedOrAbove && completelyAbove) {
//           nextEl.classList.add(className);
//           nextEl.style.top = headerHeight + 'px';
//         } else if (!touchedOrAbove) {
//           nextEl.classList.remove(className);
//         }
//       }
//       ticking = false;
//     }

//     function onScroll() {
//       if (!ticking) {
//         ticking = true;
//         requestAnimationFrame(check);
//       }
//     }
//     window.addEventListener('scroll', onScroll, { passive: true });
//     requestAnimationFrame(check);

//     return function destroy() {
//       window.removeEventListener('scroll', onScroll);
//       window.removeEventListener('resize', onResize);
//       mo.disconnect();
//     };
//   }

//   function throttle(fn, wait = 100) {
//     let last = 0;
//     return function (...args) {
//       const now = Date.now();
//       if (now - last >= wait) {
//         last = now;
//         fn.apply(this, args);
//       }
//     };
//   }

//   addClassWhenTouchingHeader('.mobile-sticky-addtocart-btn', 'sticky-addtocart-mobile', {
//     headerSelector: '.header_main'
//   });
// });

// function whenPageReady() {
//   return new Promise((resolve) => {
//     if (document.readyState === "complete") {
//       // When the page is already loaded and user clicks the A2C button
//       resolve();
//     } else {
//       // When the page is not yet loaded and user clicks the A2C button
//       window.addEventListener("load", resolve, {once: true});
//     }
//   });
// }

// async function test() {
//   console.time("Page ready time");
//   await whenPageReady();
//   console.timeEnd("Page ready time");
//   console.log("Page is ready");
// }
// test();

document.addEventListener("DOMContentLoaded", () => {
  const header = document.querySelector(".header_main");
  const trigger = document.querySelector(".mobile-sticky-addtocart-btn");
  if (!header || !trigger) return;

  const target = trigger.nextElementSibling;
  if (!target) return;

  let ticking = false;
  let isSticky = false;

  function getHeaderHeight() {
    return header.offsetHeight;
  }

  function updateSticky() {
    const headerHeight = getHeaderHeight();
    const rect = trigger.getBoundingClientRect();

    // Trigger has crossed the top of the viewport
    if (rect.top <= 0) {
      if (!isSticky) {
        isSticky = true;
        target.classList.add("sticky-addtocart-mobile");
        target.style.top = headerHeight + "px";
      }
    } else {
      if (isSticky) {
        isSticky = false;
        target.classList.remove("sticky-addtocart-mobile");
        target.style.top = "";
      }
    }
  }

  if (window.innerWidth <= 1024) {
    window.addEventListener(
      "scroll",
      () => {
        if (ticking) return;
        ticking = true;

        requestAnimationFrame(() => {
          ticking = false;
          updateSticky();
        });
      },
      {passive: true}
    );
  }

  window.addEventListener("resize", updateSticky);

  // Run once on load
  updateSticky();
});
